/* 

----- Basket Functionality ----- 
- Basket Preview / summary functionality.
- Adding & removing items from basket.
- Basket page controls such as updating, remove all & delivery estimate functionality.
- Voucher code logic.

*/

//--- Global Variables ---
//The element which will have it's content replaced with the updated basket details
const basketContainer = "#basketSummaryContainer";
//Update basket triggerd
const basketUpdateTrigger = expressSelectors()['basket']['add-trigger'];

// Ajax operation variable name.
const ajaxAction = "operation=";
// Ajax Product reference variable name.
const referenceName = "reference=";
// Product id variable name.
const productIdName = "id";
// Ajax Quantity variable name.
const quantityName = "quantity=";

const basketFormId = expressSelectors()['basket']['form'];

$('body').on('click', basketUpdateTrigger, function(event) { 
  event.preventDefault();
});

//--- Basket Preview --- 
$('.headerBasketToggle').click(() => {
  triggerBasketPreview();
});

$('body').on('submit', expressSelectors()['basket']['add-form'], function(event) {
  event.preventDefault();
})

// TODO: this could do with a re-write as it is very rigid when we start removing parts of the navigiation we may run into issues regarding the popup's position.
//Onload get the basket position.
var basketPosition = $('#nav-right-container').offset();
//If the window is resized then get the new position.
$(window).on('resize', () => {
  triggerBasketPreview(false, true, true);
  //Adding timeout to allow for basket to close before taking new measurement.
  setTimeout(() => {
    basketPosition = $('#nav-right-container').offset();
    basketPreviewPosition();
  }, 50);
 
});

function basketPreviewPosition(sticky = false) {
  // If there is no basket preview then exit.
  if ($(basketContainer).length == 0) {
    return false;
  }
  if ($(basketContainer).hasClass('sticky')) {
    if (AXISDebug.level() >= 4) {
      AXISDebug.output(1,"Basket Preview position: sticky basket is active");
    }
    sticky = true;
  }
  if (sticky) {
    var currentBreakpointValue = currentBreakpoint();
    //If in mobile remove any desktop sticky positioning, else apply destop positioning.
    if (currentBreakpointValue <= 2) {
      if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Preview position: current breakpoint is <= 2 ( mobile view, defaulting position to top: 0 & left: 0.");
      }
      $(basketContainer).css('top', 0);
      $(basketContainer).css('left', 0);
    } else {
      if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Preview position: current breakpoint is greater than 2 so basket position is: ", basketPosition);
      }
      // Work out position, first find the right size of the container then deduct the popup's width from that position, adding 1px so the recently added fully overlaps the summary in the header.
      let position = ((basketPosition.left + $('#nav-right-container').outerWidth()) - $('#recentlyAdded').outerWidth() + 1);
      // Set position.
      $('#recentlyAdded').css('left', position);
    }
  }
}
if ($(basketContainer).length) {
  basketPreviewPosition();
}

var basketPreviewCloseInterval = 0;
var isBasketPreviewPaused = false;

function triggerBasketPreview(updateBasket = false, forceClose = false, suppressOverlay) {
  if (!$('#basketSummaryContainer').hasClass("active")) {
    // Adds update class to show minified information instead of full basket contents.
    if (updateBasket) {
      if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Update Basket: Basket has been updated, triggering preview.");
      }
      $(basketContainer).addClass('update');
      // Add listener to pause basket closing if use hovers the slide out.
      $('#recentlyAdded').on('mouseenter', function() {
        isBasketPreviewPaused = true;
      });
      $('#recentlyAdded').on('mouseleave', function() {
        isBasketPreviewPaused = false;
      });
    }
    // Set basket preview position.
    basketPreviewPosition(true);
    // Activates the preview.
    $(basketContainer).addClass('active sticky');
    //Applies the overlay, setting timeout to allow for slide out animation.
    if (updateBasket == false && forceClose == false) {
      setTimeout(() => {
        pageOverlay(false, true);
      }, 500);
    }

    let timerCount = $(basketContainer).data('update-basket-pause');

    if (!timerCount) {
      if (AXISDebug.level() >= 4) {
        AXISDebug.output(1,"Update basket: updae-basket-pause not defined defaulting to 4000");
        timerCount = 4000;
      }
    }

    if (updateBasket == true) {
      basketPreviewCloseInterval = setInterval(function() {
        if (!isBasketPreviewPaused) {
          let closePreview = closeBasketPreview();
        } else {
          if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Update basket: keeping basket preview open due to the mouse being within the area.")
          }
        }
      }, timerCount);

    } else {
      $("body").on('click', '#pageOverlay', function () {
        pageOverlay(true);
        $(basketContainer).removeClass('active sticky');
      });
    }
  }
  // This is used for viewport resizing and getting the posistion of the basket.
  if (forceClose) {
    //Reset active state.
    $(basketContainer).removeClass('active sticky');
    //Reset positioning
    //$(basketContainer).css('left','initial');
    if (!suppressOverlay) {
      pageOverlay(true);
    }
  }
}

function closeBasketPreview() {
  if (AXISDebug.level() >= 3) {
    AXISDebug.output(1,"Update Basket: Closing preview.");
  }
  // Clear interval.
  clearInterval(basketPreviewCloseInterval);
  $(basketContainer).removeClass("active update");
  
  if ($(basketContainer).hasClass('sticky')) {
    $(basketContainer).removeClass('sticky');
    $(basketContainer).css('left', 'inherit');
  }
  // Remove any listeners that are no longer needed.
  $('#recentlyAdded').off('mouseenter mouseleave');

  return true;
}

$(basketContainer).find('.close-button').on('click', function(event) {
  event.preventDefault();
  if (AXISDebug.level() >= 3) {
    AXISDebug.output(1, "Basket: Closing basket preview.");
  }
  triggerBasketPreview(false, true);
});


//----- Basket Page -----
// Define object used to determine whether to post or not.
let basketUpdateStatus = {}

basketUpdateStatus["changeCount"] = 0;
//basketUpdateStatus["postPrepareTimer"] = 0;

function basketInstantUpdate() {
  let updateTriggers = $('#basket-table').find(".input-number");
  // Check if quantity selectors are active.
  if (updateTriggers.length) {
    // Start listening on each input trigger. 
    updateTriggers.on('change', function(event) {
      let context = $(this);
      // Prevent event bubbling.
      event.stopImmediatePropagation();
      // Form Context.
      var getForm = context.parents('form');
      // Make sure quantity input is valid ( free text ).
      let isValid = (context.parents('.is-invalid-quantity').length > 0 ? false : true);
      if (!isValid) {
        if (AXISDebug.level() >= 2) {
          AXISDebug.output(2,"Basket Update: Auto update cancelled quantity selector invalid.");
        }
        $('.update-basket').prop('disabled', true);
        return false;
      } else {
        $('.update-basket').prop('disabled', false);
      }
      // Bump the change count.
      basketUpdateStatus["changeCount"]++;

      if (basketUpdateStatus["changeCount"] == 1) {
        AXISDebug.output(1, "Basket: Starting update timeout");
        basketUpdateTimer(getForm);
      } else if (basketUpdateStatus["changeCount"] > 1) {
        AXISDebug.output(1, "Basket: Another input has been changed restarting post prep timeout.");
        basketUpdateTimer(getForm, true);
      }
    });
  }
}

function basketUpdateTimer(getForm, reInit = false) {
  let postPrepareTimer = 0;
  if (reInit) {
    AXISDebug.output(1, "Basket: Re-initialise update timeout.")
    // Stop prepare interval.
    clearTimeout(postPrepareTimer);
  }
  // Start prepare post timer, once timeout finished run prepare post function.
  postPrepareTimer = setTimeout(() => {
    //console.log("timeout: " + postTimeout)
    // Clear the timeout ready for next post,
    clearTimeout(postPrepareTimer);
    if (basketUpdateStatus["changeCount"] == 1) {
      // Get the data.
      let data = ajaxAction + "update-basket&" + getForm.serialize();
      let updateBasket = basketPost(getForm, data);
      basketUpdateStatus["changeCount"] = 0;
    } else {
      // Clear timout.
      clearTimeout(postPrepareTimer);
      // De-increment the change count so when it hits 1 the post function gets fired.
      basketUpdateStatus["changeCount"]--;
      AXISDebug.output(1, "Basket: De-incrementing change counter" + basketUpdateStatus["changeCount"]);
    }
  }, 1000);
}

if ($('#basket').length) {
  basketInitialise();
}

// Creating general stub function to re-initialisation so axis-basket.js can access this functionality, this can be removed once 820194 has been completed.
window.basketInitialiseForm = () => {
  return basketInitialise(true);
}


// Initialise basket functionality. 
function basketInitialise(reInit) {
  if (reInit) {
    // Enable notifcation for stock notification.
    //stockIndicators.initialiseAll($('#basket-form'));
    // Enabled basket images.
    basketImagesInterchange();
    // Re-enable sticky summary.
    basketSummarySticky();
    // Re-initialise select dropdowns.
    // $('#basket-table').find('.control.select').each(function() {
    //   let item = $(this);
    //   let initalise = AXISInputs.initaliseControlSelect(item);
    // });
    // If there any disabled buttons then intialise.
    // AXISInputs.disabledButtonsInitialise($('#basket-form'));
    // Get the content container on the basket page.
  } else {
    // Handles Remove & Empty basket buttons.
    basketControls();
  }
  // Enable delivery selectors.
  basketDeliverySelectors();
  // Handles the basket submission.
  basketSubmission();

  basketInstantUpdate();

  summarySubmitListeners();
  // Equalise price columns.
  //AXISAccount.initialiseEqualise($('#basket-table .text-container'));
  // DEPRICATED: Using axis-table-column-equaliser instead.
  //tableTextEqualiser.initialise($('#basket-table .text-container'));
}

// Used to re-initialise basket images after ajax.
function basketImagesInterchange() {
  let basketImages = $('td.basket-description-col .image img');
  basketImages.each(function() {
    let context = $(this);
    let interchange = new Foundation.Interchange(context, {});
  });
}

// re-initialise basket summary after ajax.
function basketSummarySticky() {
  // Sticky element.
  let basketSummarySticky = $('#basket-summary');
  // Sticky configuration.
  let stickyOptions = {
    topAnchor: "basket-sticky-summary-container:top",
    btmAnchor: "basket-sticky-summary-container:bottom",
    containerClass: "summary-sticky-container",
    stickyOn: "large"
  };
  // If basket summary exists then initialise sticky.
  if (basketSummarySticky.length > 0) {
    let sticky = new Foundation.Sticky(basketSummarySticky, stickyOptions);
  }
}

function summarySubmitListeners() {
  AXISDebug.output(1,"Axis Basket: Initialising summary click listeners.");
  $('.summary-input-submit').on('click', function(event) {
    // Store button context.  
    let context = $(this);

    let input = context.data('button-validate')
    if (AXISDebug.level() >= 2) {
      AXISDebug.output(1,"Axis Basket: Waiting for basket summary input to validate.");
    }
    $(document).on('validation-button-isvalid', function(event, data) {
      // Make sure event belongs to this input and is valid before posting.
      if (input == data['id'] && data['is-valid']) {
        // Get container.
        let container = context.parent('.summary-input-container');
        // Store parent form.
        let parentForm = context.parents('form');
        // Add input name + value to callback.
        let inputValue = container.find('input').val();
        let valueName = container.find('input').attr('name');
        inputValue = valueName + "=" + inputValue; 
        // Post back to server.
        basketPost(parentForm, inputValue, false, context);
      }
    });    
  });

  $('.summary-input').on('keydown', function(event) {
    // Store what key has been pushed.
    let key = event.key;  
    // Store input context.  
    let context = $(this);
    // If enter is hit then validate.
    if (key == "Enter") {
      event.preventDefault();
      //summaryInputValidation(context);
      context.next('button').trigger('click');
      return false;
    }
  });

  function summaryInputValidation(context) {
    // Get container.
    let container = context.parent('.summary-input-container');
    // Store parent form.
    let parentForm = context.parents('form');
    // Store whether the input is valid.
    let isValid = false;

    if (container) {
      isValid = validateBasketInput(container);
    } else {
      AXISDebug.output(2,"Basket: Could not find container so validation was not carried out.")
    }
    if (isValid) {
      let inputValue = container.find('input').val();
      let valueName = container.find('input').attr('name');

      if (valueName == undefined) {
        AXISAjax.output(3,"Basket: You must specify a input name for the summary inputs.");
        return false;
      }

      inputValue = valueName + "=" + inputValue; 
      // Post back to server.
      basketPost(parentForm, inputValue, false, context);
      return true;
    } else {
      AXISDebug.output(2, "Basket: " + context.attr('id') + " is invalid.");
      container.addClass('invalid');
      // If a valid input is then inputted then remove the invalid class.
      container.find('input').on('change paste keyup', function() {
        if (validateBasketInput(container)) {
          container.removeClass('invalid');
          container.find('input').off('change paste keyup');
        }
      });
      event.preventDefault();
      return false;
    }
  }
}

function basketControls() {
  // Remove from basket button.
  $('body').on('click', expressSelectors()['basket']['remove-trigger'], function(event) {
    // Prevent default behavour.
    event.preventDefault();
    // Button Context.
    let context = $(this);
    //The product reference
    let productReference = context.attr(expressSelectors()['basket']['product-reference']);
    // Get product id.
    let productId = context.attr(expressSelectors()['basket']['product-id']);
    // Fallback, if no reference then fallback to using the Id for the reference 855854.
    if (!productReference) {
      productReference = context.attr(expressSelectors()['basket']['product-id']);
      productId = undefined;
    }
    // Get Operation.
    let operation = AXISAjax.getOperation(context);
    //Remove product.
    let data = operation + "&" + referenceName + productReference + (productId ? "&" + productIdName + "=" + productId : "");
    // Post Data.
    basketPost(context, data, true, context);
  });
  // Empty basket button.
  $('body').on('click', expressSelectors()['basket']['clear-trigger'], function(event) {
    // Prevent default behavour.
    event.preventDefault();
    // Button Context.
    let context = $(this);
    // Check if this button as a confirmation modal attached.
    const confirm = context.attr(expressSelectors()['modals']['confirm']);
    if (confirm) {
      // Check if confirmed.
      const isConfirmed = context.attr(expressSelectors()['modals']['confirmed']);
      if (isConfirmed == undefined) {
        return false;  
      }
    }
    // Get Operation.
    let operation = AXISAjax.getOperation(context);
    // Form context.
    let formContext = context.parents('form');
    // Data.
    let data = operation;
    // Post.
    basketPost(formContext, data, false, context);
  });
  // Update basket button.
  $('body').on('click', expressSelectors()['basket']['update-trigger'], function(event) {
    // Prevent default behavour.
    event.preventDefault();
    // Button Context.
    let context = $(this);
    // Get Operation.
    let operation = AXISAjax.getOperation(context);
    // Form context.
    let formContext = context.parents('form');
    // Data.
    let data = operation;
    // Collect all data in basket.
    data = data + "&" + formContext.serialize();
    // Post.
    basketPost(formContext, data, false, context);
  });

}

function basketDeliverySelectors() {
  $("#AXISAreaDropDown, #AXISDeliveryDropDown").on('change', function(event) {
    event.stopPropagation();
    // Store context.
    let context = $(this);
    // Get Operation.
    let operation = AXISAjax.getOperation(context);
    // Variable name;
    let areaVariableName = $('#AXISAreaDropDown').attr('name');
    let deliveryVariableName = $('#AXISDeliveryDropDown').attr('name');
    // Value.
    let areaValue = $('#AXISAreaDropDown').val();
    let deliveryValue = $('#AXISDeliveryDropDown').val();
    // Get parent form.
    let form = context.parents('form');

    let data = operation + "&" + areaVariableName + "=" + areaValue + '&' + deliveryVariableName + "=" + deliveryValue;

    // Post back to server.
    basketPost(form, data, false, context);
  });
}

function validateBasketInput(container) {
  let inputValue = container.find('input').val();
  AXISDebug.output(1,"Basket: validating input here is the value: " + inputValue);
  let pattern = new RegExp(container.find('input').data('validate'));

  return pattern.test(inputValue);
}

function basketSubmission() {
  $(basketFormId).on('submit', function(event) {
    // Prevent Default Behavour.
    event.preventDefault();
    // Store the form context.
    let getForm = $(this);
    // Get form data.
    let data = getForm.serialize();
    // Prepare / post data through AJAX.
    //basketPost(getForm, data);
  });
}

function basketVoucherAction() {
  let voucherAction = "";
  //Get the voucher button into context.
  var voucherButton = document.getElementById("voucher-submit-button");
  //If the button is using the name attribute (which is used for the voucher action).
  if (voucherButton.hasAttribute("name")) {
    //Get the voucher action.
    voucherAction = $(voucherButton).attr("name");
    //Set the voucher action for submission.
    //Checks the voucher action.
    if (voucherAction == "remove") {
      //Gather all form data.
      voucherAction = "remove-voucher";
    } else if (voucherAction == "apply") {
      //Get form elements.
      voucherAction = "add-voucher";
    } else {
      AXISDebug.output(2,"Voucher: invalid action.");
    }
  } else {
    voucherAction = null;
    AXISDebug.output(2, "No voucher action present, this is defined using the name attribute");
  }
  return voucherAction;
}

function vatNumberAction() {
  let vatAction = "";
  // Get VAT button context.
  let vatNumberButton = document.getElementById("vat-number-submit");
  // If button has attribute.
  if (vatNumberButton.hasAttribute("name")) {
    // Get vat action.
    vatAction = $(vatNumberButton).attr("name");
    if (vatAction == "remove") {
      vatAction = "remove-vat-number";
    } else if (vatAction == "apply") {
      vatAction = "add-vat-number";
    } else {
      AXISDebug.output(2,"Vat number: invalid action.");
    }
  } else {
    vatAction = null;
    AXISDebug.output(2, "Vat number: no vat number action present, this is defined by using the attribute name on the button");
  }
  return vatAction;
}

// When on the basket page, all basket modification go through this function.
function basketPost(formContext, data = null, isAnchor = false, inputContent = "") {
  let emptyBasket = false;
  // Get the postback location.
  let postUrl = "";  
  postUrl = AXISAjax.postUrl(formContext);
  AXISDebug.output(1,"Basket: Attempting to post to this URL: " + postUrl);

  if (inputContent) {
    if (inputContent.attr('id') == "voucher-input" || inputContent.attr('id') == "voucher-submit-button") {
      // Find out whether we're removing or adding the voucher.
      let voucherAction = basketVoucherAction();
      // If voucherAction has an action then add it to the data string.
      if (voucherAction == "add-voucher") {
        data = ajaxAction + voucherAction + "&" + data;
      } else if (voucherAction == "remove-voucher") {
        data = ajaxAction + voucherAction
      }
    }
    if (inputContent.attr('id') == "vat-number" || inputContent.attr('id') == "vat-number-submit") {
      let vatAction = vatNumberAction();
      if (vatAction == "add-vat-number") {
        data = ajaxAction + vatAction + "&" + data;
      } else if (vatAction == "remove-vat-number") {
        data = ajaxAction + vatAction
      }
    }
    if (inputContent.hasClass('empty-basket')) {
      emptyBasket = true;
    }

  }
  // If this is not an anchor posting data then get the form id.
  let formId;
  if (isAnchor != true) {
        formId = formContext.attr('id');
  } else {
    // Else use the anchor context.
    formId = formContext;
  }

  data = data + "&return-basket=true";

  AXISAjax.post(postUrl, data, 'JSON' , formContext, true).then((data) => {
    // Get response.
    let response = data['data'];
    // If on the basket page.
    if ($(basketFormId).length && response) {
       // Clear out old content.
      let cleanup = AXISAjax.cleanup($(basketFormId));
      // If the old content has been remove then add new content and initialise JS functionality.
      if (cleanup) {
        // Add New content to the DOM.
        $('#basket-content-container').html(response.basketContent);
        // Update basket preview.
        $('[' + expressSelectors()['basket']['summary-container'] + ']').replaceWith(response.popupContent);
        // Initialise JS for new content.
        //basketInitialise(true);
        let basketContentContainer = $(expressSelectors()['basket']['basket-page-content-container']);
        if (basketContentContainer.length) {
          // Go through normal JS initialiser which natually calls basketInitialise.
          AXISAjax.reInitialiseJs(basketContentContainer);
        } else {
          AXISDebug.output(3,"Basket: Failed to find basket content container to initialise after callback.");
        }
        // Check if basket total value has been provided.
        let basketTotalValue = (response.hasOwnProperty('basket-total-value') ? response['basket-total-value'] : false);
        // If provided.
        if (basketTotalValue) {
          // Check dom if there are any elements to update.
          let totalValueDisplay = $('[' + expressSelectors()['basket']['total-value'] + ']');
          // If any exist.
          if (totalValueDisplay.length) {
            totalValueDisplay.html(basketTotalValue).text();
          }
        }
        // If empty basket then return to top of the page.
        if (emptyBasket) {
          //Uses Smooth Scroll to manually move to content container.
          Foundation.SmoothScroll.scrollToLoc($('#basket'));
        }
        let modals = AXISModals.activeModals();
        if (modals.length > 0) {
          // Check if any modals are active.
          AXISModals.modalClose();
        }

        // Find basket table.
        // let basketTable = $('#basket-table');
        // if (basketTable.length) {
        //   // Find last item.
        //   let lastItem = basketTable.find('tbody tr').last();
        //   // Scroll to last item.
        //   if (lastItem) {
        //     Foundation.SmoothScroll.scrollToLoc(lastItem, {threshold: 50,offset: (getHeaderSize() + 100)});
        //   }
        // }
        AXISBasket.updateBasketItemCountDisplay(response);
      }
    }
   }).catch((error) => {
    AXISDebug.output(3,"Basket:",error);
   });
  return true;
} 






